import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Clear } from '@material-ui/icons';
import * as styles from './styles/styles.module.scss';
import LegacyModal from 'components/LegacyModal';
import OutlinedTextField from '../../components/forms/textFields/OutlinedTextField';
import * as formStyles from '../forms/styles/styles.module.scss';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const CustomMapSourceModal = ({ source, closeModal, handleSubmit }) => {
  const [formParams, updateFormParams] = useState({ ...source });

  const updateForm = payload => {
    updateFormParams(prevState => {
      return { ...prevState, ...payload };
    });
  };

  const handleTextChange = e => {
    const { name, value } = e.currentTarget;
    const payload = { [name]: value };

    updateForm(payload);
  };

  const handleCtaClick = e => {
    handleSubmit(e, formParams);
  };

  return (
    <LegacyModal handleBackgroundClick={closeModal}>
      <div className={`${formStyles.formUploadContainer} ${styles.formContainer}`}>
        <div className={formStyles.clearContainer}>
          <button type="button" className={formStyles.clearIcon} onClick={closeModal} data-testid="closeIcon">
            <Clear />
          </button>
        </div>
        <>
          <div className={styles.header}>
            <div className={formStyles.title}>Custom Map Source</div>
          </div>
          <div className={formStyles.form}>
            <div className={styles.formSection}>
              <OutlinedTextField label={'Source URL'} value={formParams.url} changeHandler={handleTextChange} name="url" />
              <div>URL must be for a WMS raster tile source, containing {'{x}, {y} and {z}'} placeholders.</div>
            </div>
            <div className={formStyles.buttonContainer}>
              <button className={formStyles.uploadButton} type="button" onClick={handleCtaClick}>
                {StringConstantsMixin.strings.SUBMIT}
              </button>
              <button className={formStyles.cancelButton} type="button" onClick={closeModal}>
                {StringConstantsMixin.strings.CANCEL}
              </button>
            </div>
          </div>
        </>
        )
      </div>
    </LegacyModal>
  );
};

CustomMapSourceModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  source: PropTypes.object
};

export default CustomMapSourceModal;
